/** Sort tab keys for UI/i18n; API receives uppercase via `normalizeSolutionsPeopleSort`. */
export const solutionsPeopleSortItems: string[] = [
  'newest',
  'oldest',
  'titleAsc',
  'titleDesc',
];

/** Normalizes sort query values to API uppercase (e.g. `NEWEST`, `TITLEASC`). */
export function normalizeSolutionsPeopleSort(value: string): string {
  return value.toUpperCase();
}
